<template>
    <div class="page-header">
        <BaseBreadcrumb :breadcrumbs="breadcrumbs" />
        <ContextToolbar :highlight="ctxStore.highlight" />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { BaseBreadcrumb } from '@fondationcss/ui';
import ContextToolbar from '@/components/context-toolbar.vue';
import { usePageHeaderStore } from '@/stores/page-header-store';
import { useContextToolbarStore } from '@/stores/context-toolbar-store';

const store = usePageHeaderStore();
const ctxStore = useContextToolbarStore();

// Ensure `to` is always a string as required by BaseBreadcrumb
const breadcrumbs = computed(() =>
    store.breadcrumbs.map(b => ({ ...b, to: b.to ?? '#' }))
);
</script>

<style scoped>
.page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    flex-shrink: 0;
    min-height: 40px;
    gap: 16px;
}
</style>
